export default __webpack_public_path__ + "static/media/icon-nav-custom-fields.e43a9702.svg";